import { render } from "./WCCartDrawerGiftCard.vue?vue&type=template&id=2341ff2e&scoped=true"
import script from "./WCCartDrawerGiftCard.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerGiftCard.vue?vue&type=script&lang=js"

import "./WCCartDrawerGiftCard.vue?vue&type=style&index=0&id=2341ff2e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2341ff2e"]])

export default __exports__